import { logEvent } from '../utils/logger';

export async function initFG() {
	try {
		const { init } = await import('./fg');
		await init();
	} catch (e) {
		logEvent(`Ошибка загрузки FG: ${String(e)}`);
	}
}
